import React from 'react';

import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';



export default function ControlDivider() {
 
    return (
        <React.Fragment>
            <Box width="10px" />
            <Divider 
                orientation="vertical" 
                flexItem 
                sx={{
                    background: 'rgba(255,255,255,0.5)',
                    color: 'white',
                    root: {
                    background: 'rgba(255,255,255,1)',
                },}} />
            <Box width="10px" />
        </React.Fragment>
    )
}